var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-button',{attrs:{"variant":"primary"},on:{"click":_vm.launchWhatsAppSignup}},[_vm._v("Login com Facebook")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }